module.exports = "/img/_/_/_/assets/images/creeper/battle/common//27.jpg?485d86daed9b99af61914edbe13b69c0";